import { Uuid } from 'src/app/entities/value-objects/uuid/uuid';
import { EntityInterface } from 'src/app/entities/interfaces/entity-interface';

export class BaseEntity implements EntityInterface {
  protected _id: Uuid;

  constructor(id: string | undefined) {
    this._id = new Uuid(id);
  }

  get id(): string {
    return this._id.value;
  }
}
